// Which films (assets/videos/films.json) are listed (Seán, 2026-11-05): an admin's bird on the
// Program page switches it (views/Year/Program.vue); a listed film's card is in the /Videos
// gallery (Video/films.js), and the program's ▶ for its talk goes to its page. Kept on the
// fullstack (api/v1/videos/films), fetched once per page load and shared.
import {ref} from "vue";
import {authFetch, readJson} from "@/composables/useAuthFetch";

const listings = ref({}); // key → {isListed}
let fetching = null;

async function fetchListings() {
  const response = await authFetch("/api/v1/videos/films");
  if (response.ok) listings.value = await readJson(response);
}

async function setIsListed(key, isListed) {
  const options = {method: "POST", headers: {"Content-Type": "application/json"},
    body: JSON.stringify({isListed})};
  const response = await authFetch(`/api/v1/admin/films/${key}/listed`, options);
  if (response.ok) listings.value = {...listings.value, [key]: {isListed}};
  return response.ok;
}

export default function useFilmListings() {
  fetching ||= fetchListings();
  const getIsListed = (key) => listings.value[key]?.isListed === true;
  return {listings, getIsListed, setIsListed, ready: fetching};
}
